<template>
	<div v-if="loading" class="cell small-12 medium-6 large-6">
		<PageLoading />
	</div>
	<div
		v-else-if="bookings.length > 0"
		class="cell small-12 medium-8 large-8 ProfileBookings_view--bottom-padding"
	>
		<div v-for="booking in bookings" :key="booking.resvid">
			<ProfileBookingsCard
				:resvid="booking.resvid"
				:smallBookingInfo="booking"
				:currency="booking.currency"
			/>
		</div>
		<div>
			<router-link :to="{ name: 'search' }">
				<Button :full="true" color="primary4">
					{{ $t('search.searchButtonText') }}
				</Button>
			</router-link>
		</div>
	</div>
	<div v-else class="cell small-12 medium-8 large-8">
		<div class="ProfileBookings_view__no-booknings">
			<h3 class="ProfileBookings_view__title">
				{{ $t('profile.overviewBookingsTitle') }}
			</h3>
			<p class="ProfileBookings_view__text">
				{{ $t('profile.bookingText') }}
				<router-link :to="{ name: 'search' }">
					{{ $t('navigation.accomodation') }}
				</router-link>
				<router-link :to="{ name: 'skipass' }">
					{{ $t('navigation.skipass') }}
				</router-link>
				<router-link :to="{ name: 'skirental' }">
					{{ $t('navigation.skirental') }}
				</router-link>
				{{ $t('profile.bookingOr') }}
				<router-link :to="{ name: 'skischool' }">
					{{ $t('navigation.skischool') }}
				</router-link>
			</p>
			<router-link :to="{ name: 'search' }">
				<Button size="small">
					{{ $t('profile.bookingLink') }}
				</Button>
			</router-link>
		</div>
	</div>
</template>

<script>
import store from '../../vueX/store'
import PageLoading from '../../components/atoms/PageLoading'
import ProfileBookingsCard from '../../components/molecules/ProfileBookingsCard'
import Button from '../../components/atoms/Button'

export default {
	name: 'ProfileBookings_view',
	store,
	components: {
		ProfileBookingsCard,
		Button,
		PageLoading
	},
	props: {},
	data() {
		return {
			bookings: [],
			loading: false
		}
	},
	methods: {
		logout() {
			store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(() => {
				store
					.dispatch('DELETE_TOKEN', { token: store.state.token.refreshToken })
					.then(() => {
						this.$router.push({ name: 'login' })
					})
			})
		}
	},
	computed: {},
	created() {
		this.loading = true
		store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(response => {
			if (response) {
				store.dispatch('GET_BOOKINGS', store.state.user.id).then(success => {
					if (success) {
						this.bookings = success.reverse()
						this.loading = false
					}
					this.loading = false
				})
			} else {
				this.loading = false
			}
		})
	}
}
</script>

<style scoped lang="scss">
.ProfileBookings_view {
	@include profile-background;
	&--bottom-padding {
		padding-bottom: 40px;
	}
	&__no-booknings {
		border-top: 0;
		background-color: $colorWhite;
		padding: 60px;
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
	}
	&__title {
		border-bottom: 1px solid $colorPrimary2;
		padding-bottom: 25px;
	}
	&__text {
		margin: 20px 0;
	}
}
</style>
